import React, { useContext, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import Layout, {
    getContent,
    Root,
} from "@mui-treasury/layout";
import CssBaseline from "@material-ui/core/CssBaseline";

//Styles
import "./styles.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LaunchIcon from '@mui/icons-material/Launch';
import ReplayIcon from '@mui/icons-material/Replay';
import { number } from "prop-types";
import { UserContext } from "../../../../_metronic/layout/components/Layout";


const Content = getContent(styled);
const scheme = Layout();

scheme.configureHeader((builder) => {
    builder
        .create("whatever_id")
        .registerConfig("xs", {
            position: "sticky",
        })
        .registerConfig("md", {
            position: "relative", // won't stick to top when scroll down
        });
});



const DashboardLoader = ({ dashboardLoader }: DashboardLoaderPropsInterface) => {

    const { context, setContext } = useContext(UserContext);

    
    setContext(dashboardLoader.BIID+"")

    const openNewTab = () => {
        localStorage.setItem("ReportURL", dashboardLoader?.BIURL)
        window.open('#/ReportViewer')
    }
    const reloadUrl = () => {
        var randomNumber = Math.random() + 1;
        setReloadURL(randomNumber)
    }
    const [reloadURL, setReloadURL] = useState<number>(0);

    //The page components
    return (

        <div style={{ direction: "rtl" }}>
            <Root scheme={scheme}>
                <CssBaseline />
                <div>
                    <Content>
                        <LaunchIcon
                            style={{ width: "24px", height: "24px", color: "#9AAFC4", float: "left", marginBottom: "10px" }}
                            onClick={() => openNewTab()}

                        />
                        <ReplayIcon style={{ width: "24px", height: "24px", color: "#9AAFC4", float: "left", marginBottom: "10px", marginLeft: "15px" }}
                            onClick={() => reloadUrl()} />
                        <iframe style={{ height: "85vh", width: "100%" }} src={dashboardLoader?.BIURL}
                            key={reloadURL} >

                        </iframe>
                    </Content>
                </div>
            </Root>
        </div>
    );
};

interface DashboardLoaderPropsInterface {
    dashboardLoader: any
}
const mapStateToProps = ({ dashboardLoader }: DashboardLoaderPropsInterface) => {
    return {
        dashboardLoader
    };
};

export default withRouter(connect(mapStateToProps)(DashboardLoader));
